let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jamNT")).then(() => parcelRequire('bpj8Y'));